import { fields, patients } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { pick } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import ContactList from './ContactList';
import React, { useCallback } from 'react';

const sanitizePhones = phones => phones.slice(0).map(phone => pick(phone, ...fields.PhoneModifier));

function ContactListContainer({ mutateUpdatePatient, contactItem, ...props }) {
  const onUpdateContactOrder = useCallback(
    async ({ direction, order }) => {
      const newOrder = order - direction;
      const phones = sanitizePhones(contactItem.phones);
      if (newOrder < 0 || newOrder >= phones.length) return;

      phones[order].order = newOrder;
      phones[newOrder].order = order;

      await alertOnError(
        mutateUpdatePatient({
          variables: {
            id: contactItem.id,
            modifier: { phones },
          },
        }),
      );
    },
    [mutateUpdatePatient, contactItem],
  );

  return (
    <ContactList {...props} contactItem={contactItem} onUpdateContactOrder={onUpdateContactOrder} />
  );
}

export default graphql(patients.mutateUpdatePatient, { name: 'mutateUpdatePatient' })(
  ContactListContainer,
);
